import Typography from "Components/CommonComponents/Typography";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { useEffect } from "react";
import { useState, useContext } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { UserInfoContext } from "Context/CommonContext";
// import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import LeftArrow from "Assets/Icons/LeftArrow";
import useMasterContext from "Context/MasterContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import FilterIcon from "Assets/Icons/FilterIcon";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import cx from "classnames";
const { RangePicker } = DatePicker;
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  id?: any;
}
const ColStyled = styled<any>(Col)`
  display: flex;
  margin-left: 0px;
  flex-direction: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "row" : "column"};
  padding-right: 0px;
  padding-left: 0px;
  justify-content: end;
`;
const CardBodyStyled = styled<any>(CardBody)`
  padding: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "16px" : "12px"};
`;
export const nullOption = [{ label: "All", key: "all", value: null }];
type IFacultiesFilter = {
  mode?: string;
  onSelectClickHandler?: any;
  region: any[];
  applyFilter: any;
  filterState: any;
  setFilterState: any;
  resetHandler: any;
  subjects: any[];
  headerTitle: string;
  branchOrRegionId: any;
  dateRange: any[];
  subjectFilterIncluded?: any;
  setDates?: any;
  selectedStream?: any;
};
const FacultiesFilter = ({
  mode,
  applyFilter,
  filterState,
  setFilterState,
  resetHandler,
  headerTitle,
  branchOrRegionId,
  subjects,
  dateRange,
  subjectFilterIncluded,
  selectedStream,
}: IFacultiesFilter) => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { setFacultyPerformance } = useContext(FacultyPerformanceContext);
  const { masters } = useMasterContext();
  const { screen }: any = useWindowSize();
  const [stream, setStream] = useState<selectInterface[]>(
    userInfo?.userStreams ? nullOption.concat(userInfo?.userStreams as any) : []
  );
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  const preFilterStream = selectedStream;
  // const [branchOptions, setBranchOptions] = useState<any>([]);
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [dateValue, setdateValue] = useState<any>(dateRange ? dateRange : []);
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Stream",
      nickName: "streamIds",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Subject",
      nickName: "subject",
      data: subjects,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Date",
      nickName: "yearMonth",
      data: dateRange,
      singleSelect: false,
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Stream",
        nickName: "streamIds",
        data: userInfo?.userStreams as any,
        singleSelect: true,
        filterSelectedData: [filterState.streamIds] as any,
      },
      {
        name: "Subject",
        nickName: "subject",
        data: subjects,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Date",
        nickName: "yearMonth",
        data: dateRange,
        singleSelect: false,
        filterSelectedData: [],
      },
    ]);
  }, [userInfo?.userStreams, masters?.userAssignedBranches]);
  useEffect(() => {
    setStream(userInfo?.userStreams as any);
  }, [userInfo, userInfo?.userStreams]);
  useEffect(() => {
    setdateValue(dateRange);
  }, [dateRange]);
  const handleAddFilterArrayList = (name: string, val: any) => {
    if (name === "region") {
      setFilterState((prevState: any) => ({
        ...prevState,
        branch: null,
        yearMonth: dateRange,
        [name]: val,
      }));
    }
    if (name === "yearMonth") {
      if (val === null) {
        setFilterState((prevState: any) => ({
          ...prevState,
          [name]: dateRange[0],
        }));
      } else {
        const resultantMonthArray = val;
        setFilterState((prevState: any) => ({
          ...prevState,
          [name]: resultantMonthArray,
        }));
      }
    } else {
      setFilterState((prevState: any) => ({
        ...prevState,
        yearMonth: dateRange,
        [name]: val,
      }));
    }
  };

  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      if (ele.nickName === "yearMonth") {
        if (ele.filterSelectedData === null) {
          obj["yearMonth"] = dateRange[0];
        } else {
          const resultantMonthArray = filterArrayByMinMaxKey(
            ele.filterSelectedData,
            dateRange
          );
          setfilterheadingListing((prev: any) =>
            prev.map((item: any) =>
              item.name === "Date"
                ? { ...item, filterSelectedData: resultantMonthArray }
                : item
            )
          );
          obj["yearMonth"] = resultantMonthArray;
        }
      } else {
        obj[ele.nickName] = ele.singleSelect
          ? ele.filterSelectedData[0]
          : ele.filterSelectedData;
      }
    });
    setFacultyPerformance(obj);
    setFilterState(obj);
    applyFilter(obj);
  };
  const handleClearAllFilter = () => {
    const clearedFilter = {
      region: null,
      streamIds: null,
      subject: null,
      branch: null,
    };
    setFilterState(clearedFilter);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setdateValue(dateRange);
    // setBranchOptions([]);
    setfilterheadingListing(filterheadingListingArr);
    resetHandler && resetHandler();
    setIsFilterApplied(false);
  };
  // const handleOptionForBranches = (regionIds: any) => {
  //   if (regionIds && masters && Array.isArray(masters?.userAssignedBranches)) {
  //     const filteredbranches = masters?.userAssignedBranches.filter(
  //       (item: any) => regionIds.includes(String(item.regionCode))
  //     );
  //     setBranchOptions(filteredbranches);
  //   }
  // };

  function filterArrayByMinMaxKey(array1: any, array2: any): any {
    const minKey = Math.min(...array1.map((item: any) => item.key));
    const maxKey = Math.max(...array1.map((item: any) => item.key));
    const filteredArray = array2.filter(
      (item: any) => item.key >= minKey && item.key <= maxKey
    );

    return filteredArray;
  }

  function containsSubstringCaseInsensitive(
    mainString: string,
    subString: string
  ): boolean {
    const regex = new RegExp(subString, "i");
    return regex.test(mainString);
  }

  const HandleApplyFilter = (filterState: any) => {
    setFacultyPerformance(filterState);
    applyFilter(filterState);
    setIsFilterApplied(true);
  };
  const filterStateCopy = { ...filterState };
  if (preFilterStream?.label == filterStateCopy?.streamIds?.label) {
    delete filterStateCopy["streamIds"];
  }
  const filterLength = Object.values(filterStateCopy).filter(
    (ele: any) => ele != null
  ).length;

  return (
    <div className={["xs", "sm", "md"].includes(screen) ? "" : "pl-5 pr-3"}>
      {["xs", "sm", "md"].includes(screen) && (
        <FilterSliderComponent
          width={"100%"}
          isPaneOpen={isPaneOpen}
          setisPaneOpen={() => {
            setisPaneOpen(!isPaneOpen);
          }}
          hideHeader={true}
          filterState={filterState}
          filterheadingListing={
            subjectFilterIncluded
              ? filterheadingListing
              : filterheadingListing.filter((ele) => ele.name != "Subject")
          }
          resetHandler={handleClearAllFilter}
          setfilterheadingListing={setfilterheadingListing}
          applyFilterHandler={applyFilterHandler}
        ></FilterSliderComponent>
      )}

      {["xxl", "xl", "lg"].includes(screen) ? (
        <Card className="w-100 mt-3 FacultiesFilterCard mb-0">
          <CardBodyStyled screen={screen}>
            <CardTitle tag="h5" className="titleBar mb-0">
              <Row className="rowMain d-flex align-items-center mb-0">
                <Col
                  xxl="5"
                  xl="5"
                  lg="5"
                  md="4"
                  sm="6"
                  xs="6"
                  className="d-flex flex-row p-0 align-items-center"
                >
                  {mode &&
                    (mode == "performance" ||
                      containsSubstringCaseInsensitive(
                        headerTitle,
                        "region"
                      )) && (
                      <LeftArrow
                        className={"cursorHoverCSS mr-3"}
                        onClick={() => {
                          navigate("/admin/dashboard", {
                            replace: true,
                            state: {
                              selectedStudent: null,
                            },
                          });
                        }}
                      />
                    )}
                  {mode &&
                    containsSubstringCaseInsensitive(
                      headerTitle,
                      "branches"
                    ) && (
                      <LeftArrow
                        className={"cursorHoverCSS mr-3"}
                        onClick={() => {
                          navigate("/admin/faculties/regions", {
                            replace: true,
                            state: {
                              selectedStudent: null,
                            },
                          });
                        }}
                      />
                    )}
                  {mode && mode == "facultiesListing" && (
                    <LeftArrow
                      className={"cursorHoverCSS mr-3"}
                      onClick={() => {
                        navigate(
                          "/admin/faculties/branches/" + branchOrRegionId,
                          {
                            replace: false,
                            state: {
                              selectedRegion: branchOrRegionId,
                            },
                          }
                        );
                      }}
                    />
                  )}
                  <Typography
                    variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                    color="black"
                  >
                    {headerTitle}
                  </Typography>
                </Col>
                {["xxl", "xl", "lg"].includes(screen) ? (
                  <ColStyled
                    screen={screen}
                    xxl="7"
                    xl="7"
                    lg="7"
                    md="8"
                    sm="6"
                    xs="6"
                  >
                    <Row className="w-100 d-flex flex-row justify-content-end align-items-center">
                      <Col xxl="2" xl="2" lg="2" md="2" sm="12" xs="12">
                        <CustomSelect
                          isSelected={
                            filterState.streamIds != null ? true : false
                          }
                          width={"100%"}
                          height={"30px"}
                          top={"-3px"}
                          placeholder="Stream"
                          options={stream}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("streamIds", selected);
                          }}
                          value={filterState.streamIds}
                        />
                      </Col>
                      <Col xxl="4" xl="4" lg="4" md="3" sm="12" xs="12">
                        <RangePicker
                          format={"MMM YY"}
                          picker="month"
                          value={dateValue}
                          minDate={dayjs()
                            .subtract(11, "months")
                            .startOf("month")}
                          maxDate={dayjs().endOf("month")}
                          allowClear={false}
                          onChange={(date: any) => {
                            setdateValue(date);
                            handleAddFilterArrayList("yearMonth", date);
                          }}
                        />
                      </Col>
                      {subjectFilterIncluded && (
                        <Col xxl="3" xl="3" lg="3" md="3" sm="12" xs="12">
                          <CustomSelect
                            isSelected={
                              filterState.streamIds != null ? true : false
                            }
                            width={"100%"}
                            height={"30px"}
                            top={"-3px"}
                            placeholder="Subject"
                            options={subjects}
                            isSearchable={false}
                            menuPlacement="bottom"
                            isClearable={false}
                            menuShouldScrollIntoView={true}
                            closeMenuOnSelect={true}
                            onChange={(selected: any) => {
                              handleAddFilterArrayList("subject", selected);
                            }}
                            value={
                              filterState?.subject ? filterState?.subject : null
                            }
                          />
                        </Col>
                      )}

                      <Col
                        xxl={filterLength != 0 && isFilterApplied ? "3" : "3"}
                        xl={filterLength != 0 && isFilterApplied ? "3" : "3"}
                        lg={filterLength != 0 && isFilterApplied ? "3" : "3"}
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-row justify-content-start"
                      >
                        {" "}
                        <Button
                          size="sm"
                          color="aeslPrimary"
                          onClick={() => {
                            HandleApplyFilter(filterState);
                          }}
                          className="m-0"
                        >
                          Apply
                        </Button>
                        <div
                          onClick={() => {
                            handleClearAllFilter();
                          }}
                          className="d-flex justify-content-center align-items-center cursor-pointer pl-2"
                        >
                          <span
                            className={cx("filterSpan", "filterspanWidth", {
                              resetAllButtonStyle:
                                filterLength != 0 && isFilterApplied,
                            })}
                          >
                            Reset All{" "}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </ColStyled>
                ) : (
                  <Col
                    xxl="6"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="6"
                    xs="6"
                    className="d-flex justify-content-end p-0"
                  >
                    {filterLength != 0 ? (
                      <div className="d-flex">
                        <div
                          className="clearAllButtonStyle cursorHoverCSS"
                          onClick={() => {
                            handleClearAllFilter();
                          }}
                        >
                          Clear All
                        </div>
                        <FilterIcon
                          onClick={() => {
                            setisPaneOpen(!isPaneOpen);
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          setisPaneOpen(!isPaneOpen);
                        }}
                      >
                        <span className="filterSpan">Filter</span>
                        <FilterIcon />
                      </div>
                    )}
                    {filterLength != 0 ? (
                      <div className="filterButtonTipMB">{filterLength}</div>
                    ) : null}
                  </Col>
                )}
              </Row>
            </CardTitle>
          </CardBodyStyled>
        </Card>
      ) : (
        <div className="facultyPerformanceFilter">
          <div className="d-flex align-items-center">
            {mode &&
              (mode == "performance" ||
                containsSubstringCaseInsensitive(headerTitle, "region")) && (
                <LeftArrow
                  className={"cursorHoverCSS mr-3 mt-n2"}
                  onClick={() => {
                    navigate("/admin/dashboard", {
                      replace: true,
                      state: {
                        selectedStudent: null,
                      },
                    });
                  }}
                />
              )}
            {mode &&
              containsSubstringCaseInsensitive(headerTitle, "branches") && (
                <LeftArrow
                  className={"cursorHoverCSS mr-3 mt-n2"}
                  onClick={() => {
                    navigate("/admin/faculties/regions", {
                      replace: true,
                      state: {
                        selectedStudent: null,
                      },
                    });
                  }}
                />
              )}
            {mode && mode == "facultiesListing" && (
              <LeftArrow
                className={"cursorHoverCSS mr-3 mt-n2"}
                onClick={() => {
                  navigate("/admin/faculties/branches/" + branchOrRegionId, {
                    replace: false,
                    state: {
                      selectedRegion: branchOrRegionId,
                    },
                  });
                }}
              />
            )}
            <Typography
              variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
              color="black"
            >
              {headerTitle}
            </Typography>
          </div>
          <FilterIcon
            onClick={() => {
              setisPaneOpen(!isPaneOpen);
            }}
          />
        </div>
      )}
    </div>
  );
};
export default FacultiesFilter;
